<template>
  <div class="footer box">
    <div class="container">
      <ul class="clear">
        <li class="logo">
          <img src="../assets/images/logo.png" alt="">
        </li>
        <li>
          <p>服务时间：9:30-21:30（工作日） 午休时间：12:00-13:30</p>
        </li>
        <li class="qrcode">
          <img alt="加载失败" width="90px" height="90px" :src="qrcodePath">
        </li>
      </ul>

    </div>
    <div class="bottom">
      <p>Copyright 2019-2022 杭州畅淘网络科技有限公司 引流池 www.yinliuchi365.com <a style="color: white" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">浙ICP备19034723号-2</a></p>
      </div>
  </div>
</template>

<script>
import http from '@/axios'
export default {
  name: 'Footer',
  data () {
    return {
      qrcodePath: 'http://www.quanzhongchi365.com/pic/20190918/093a3062ae9e48cca432798239178d8c589629.jpg'
    }
  },
  methods: {
    getQRcode () {
      const _this = this
      let params = {
        id: 1
      }
      try {
        http.qrcode(params).then(({ data }) => {
          switch (data.code) {
            case 0:
              _this.qrcodePath = data.data.url
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    },
    // 获取商品id
    getGoodId () {
      let _this = this
      if (!localStorage.getItem('info')) {
        return
      }
      if (_this.$route.path === '/login' || _this.$route.path === '/register') {
        return
      }
      try {
        http.custmerGoods('').then(({ data }) => {
          switch (data.code) {
            case 0:
              let goodsListArr = data.goodsList
              localStorage.setItem('goodsList', JSON.stringify(goodsListArr))
              break
            case 401:
              _this.$message.error('账号过期，请重新登录')
              _this.$router.push({path: '/login'})
              break
            default:
              _this.$message.error(data.msg)
              break
          }
        })
      } catch (error) {
        _this.$message.error(error)
      }
    }
  },
  mounted () {
    this.getQRcode()
    this.getGoodId()
  }
}
</script>

<style lang="less" scoped>
.container {
  background: #6F3900;
  padding: 15px 100px;
  li {
    float: left;
    p {
      margin-top: 36px;
      font-size: 16px;
      color: #fff;
    }
    img {
      vertical-align: middle;
    }
  }
  .logo {
    margin-top: 30px;
    margin-right: 288px;
  }
  .qrcode {
    margin-left: 30px;
  }

}
.bottom {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: #070505;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue